import { jsx as o } from "react/jsx-runtime";
import { LoaderSize as r } from "./LoaderSize.js";
import { classNames as i } from "../../../Utils/classNames.js";
function n({ size: e }) {
  function a() {
    switch (e) {
      case r.Small:
        return "h-5 w-5";
      case r.Large:
        return "h-10 w-10";
    }
  }
  return /* @__PURE__ */ o(
    "div",
    {
      className: i(
        "border-2 border-t-primary border-gray-200/50 rounded-full animate-spin",
        a()
      )
    }
  );
}
export {
  n as PrimaryLoadingIndicator
};
//# sourceMappingURL=PrimaryLoadingIndicator.js.map
